import { Mutations } from 'vuex-smart-module';

import StampCardState from './state';

export default class StampCardMutations extends Mutations<StampCardState> {
  //
}
